import logo from '../eye-mask.svg'

const UserImage = (props:{userName: string})=>{

    return(
        <div className='chat-image flex-row center-align' >
            <img src={logo} alt="" style={{ width: '50px', height: '50px' }} />
        </div>
    )

}
 
export default UserImage